import { prod as auth0Prod } from './auth0.config';
import { Environment } from './environment.d';

export const environment: Environment = {
  production: true,
  apiProjectName: 'medicus2', // a vg-nél '', a többi produkciónál majd a projekt neve
  htmlTitlePrefix: 'Medicus II // ',
  ...auth0Prod,
};
